import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_footprint_events_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { statusIds?: number[], typeIds?: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, EndProcessingDate?: string, ErrorMessage?: string, Label?: string, Notes?: string, PublishedDate?: string, StartProcessingDate?: string, FootPrintEventStatus?: { Name?: string }, FootPrintEventType?: { Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_footprint_events_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { statusIds?: number[], typeIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, EndProcessingDate?: string, ErrorMessage?: string, Label?: string, Notes?: string, PublishedDate?: string, StartProcessingDate?: string, FootPrintEventStatus?: { Name?: string }, FootPrintEventType?: { Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_footprint_events_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { statusIds?: number[], typeIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, EndProcessingDate?: string, ErrorMessage?: string, Label?: string, Notes?: string, PublishedDate?: string, StartProcessingDate?: string, FootPrintEventStatus?: { Name?: string }, FootPrintEventType?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_footprint_events_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      statusIds?: number[], typeIds?: number[]    }) {
      return false;
    }
}
